import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=a253a2c4&scoped=true"
import script from "./Signature.vue?vue&type=script&lang=js"
export * from "./Signature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a253a2c4",
  null
  
)

export default component.exports